module.exports = __webpack_public_path__ + "img/ge-pro-desc.a632a872.png";